export const rugbyBundesligaRbaSitzungJuni2026 = {
  "id": "rba-sitzung-juni-2026-hannover",
  "title": "RBA-Sitzung am 13. Juni 2026 in Hannover: Streaming, Social Media und Spielbetrieb im Fokus",
  "slug": "rba-sitzung-juni-2026-hannover",
  "publishedAt": "2026-06-03T12:00:00Z",
  "author": "Rugby Bundesliga Redaktion",
  "language": "de",
  "readTime": "4 min",
  "tags": [
    "Rugby",
    "Bundesliga",
    "RBA",
    "Saison 2025/26",
    "Hannover",
    "Streaming",
    "Social Media"
  ],
  "excerpt": "Die Rugby Bundesliga kommt am 13. Juni 2026 zur nächsten Sitzung des Rugby Bundesligaausschusses in Hannover zusammen. Im Mittelpunkt stehen Anträge zu Streaming, Videoaufzeichnungen, Social Media und weiteren Themen des Bundesligaspielbetriebs.",
  "img": "/images/rba-sitzung-juni-2026-hannover.jpeg",
  "blocks": [
    {
      "type": "paragraph",
      "content": "Die Rugby Bundesliga kommt am 13. Juni 2026 zur nächsten Sitzung des Rugby Bundesligaausschusses in Hannover zusammen. Vertreter der Bundesligisten, des Vorstandes, Präsidiums sowie des Sportgerichts treffen sich im Vereinsheim von Rugby Ricklingen e.V., um über wichtige Themen für die kommende Spielzeit zu beraten."
    },
    {
      "type": "paragraph",
      "content": "Im Mittelpunkt der Sitzung stehen mehrere Anträge des RBA Vorsitzes, die verschiedene Bereiche des Bundesligaspielbetriebs betreffen. Dabei geht es unter anderem um die Weiterentwicklung der medialen Präsenz der Liga. So wird über neue Regelungen zu Streaming und Videoaufzeichnungen beraten. Für die 1. Bundesliga soll es künftig verbindliche Livestreams geben, während für die 2. Bundesliga feste Vorgaben für Spielaufzeichnungen vorgesehen sind."
    },
    {
      "type": "paragraph",
      "content": "Auch das Thema Social Media spielt eine Rolle. Ein Antrag sieht vor, dass Vereine bei spielbezogenen Beiträgen auf Instagram künftig den offiziellen Bundesliga Account verlinken sollen, um die Reichweite der Liga und der Vereine gemeinsam zu stärken."
    },
    {
      "type": "paragraph",
      "content": "Darüber hinaus stehen weitere organisatorische und sportliche Themen auf der Tagesordnung. Diskutiert werden unter anderem Regelungen zu zweiten Mannschaften und Spielgemeinschaften, Anpassungen beim Ausbildungsbonus sowie die Ausweitung der Livetickerpflicht auf die 2. Bundesliga."
    },
    {
      "type": "paragraph",
      "content": "Ein weiterer wichtiger Punkt ist die Diskussion über die zukünftige Teilnahme ausländischer Mannschaften am Bundesligaspielbetrieb. Im Rahmen der Sitzung soll beraten werden, ob und in welchem Umfang ausländische Teams weiterhin Teil der Liga sein sollen."
    },
    {
      "type": "paragraph",
      "content": "Die Vereine sind außerdem eingeladen, eigene Anträge und Vorschläge einzureichen, um sich aktiv an der Weiterentwicklung der Rugby Bundesliga zu beteiligen."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Ort und Termin"
    },
    {
      "type": "paragraph",
      "content": "Die Sitzung beginnt um 12:00 Uhr im Vereinsheim von Rugby Ricklingen e.V., Mühlenholzweg 4a in 30459 Hannover."
    },
    {
      "type": "footer",
      "variant": "info",
      "title": "Hinweis zur Anwesenheit",
      "content": "Der RBA weist darauf hin, dass bei Nichterscheinen eine Ordnungsgebühr in Höhe von 500 Euro anfällt."
    }
  ]
};
